import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, signal } from '@angular/core';
import { AnimateModule, SwiperDirective, WwwRouteSlug } from '@pro-connect/shared';
import { AboutUsSection } from '../../models/about-us-section';
import { SwiperOptions } from 'swiper/types';
import { Angulartics2GoogleTagManager } from 'angulartics2';

@Component({
  selector: 'app-about-us-pillars',
  templateUrl: './about-us-pillars.component.html',
  styleUrls: ['./about-us-pillars.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, NgOptimizedImage, AnimateModule, SwiperDirective],
})
export class AboutUsPillarsComponent {
  protected readonly WwwRouteSlug = WwwRouteSlug;
  protected readonly AboutUsSection = AboutUsSection;
  private readonly _angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);

  public readonly pillars = [
    {
      description: `
        Szyta na miarę oferta szkoleń i warsztatów pozwoli na rozwój umiejętności technicznych pobudzi Twoją wyobraźnie,
        a także rozwinie Twoje kompetencje biznesowe.
        Zainwestuj w swoją wiedzę i osiągaj wyższe poziomy w karierze dzięki regularnym szkoleniom PRO.CONNECT.
      `,
      leftImageSrc: 'assets/images/pages/about-us/pillar-1-left.webp',
      rightImageSrc: 'assets/images/pages/about-us/pillar-1-right.webp',
    },
    {
      description: `
        Wspólne odkrywanie świata fryzjerstwa dzięki udziałowi w dedykowanych eventach i zagranicznych wyjazdach.
        Spotkaj się z ludźmi z branży, nawiąż cenne kontakty i inspiruj się.
        Wyjątkowe wydarzenia oferują możliwość nie tylko nauki, ale także poznania branży z zupełnie nowej perspektywy.
      `,
      leftImageSrc: 'assets/images/pages/about-us/pillar-2-left.webp',
      rightImageSrc: 'assets/images/pages/about-us/pillar-2-right.webp',
    },
    {
      description: `
       Sprzedażowe wsparcie dedykowanego Business​ Partnera, który pomoże Ci w realizacji Twoich​ celów biznesowych.
       Za osiąganie wyznaczonego​ targetu sprzedażowego przygotowaliśmy nagrody​ ulepszające Twój salon.
       PRO.PROCONNECT o nie​ tylko rozwój zawodowy, ale także realna pomoc w​ sukcesie Twojego biznesu.​
      `,
      leftImageSrc: 'assets/images/pages/about-us/pillar-3-left.webp',
      rightImageSrc: 'assets/images/pages/about-us/pillar-3-right.webp',
    },
  ];

  public readonly activeSlideIndex = signal(0);
  public readonly swiperConfig: SwiperOptions = {
    spaceBetween: 0,
    slidesPerView: 1,
    freeMode: false,
    loop: true,
    updateOnWindowResize: true,
    pagination: {
      el: '.app-abo-us-pil__swi__nav--pag',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.app-abo-us-pil__swi__nav--next',
      prevEl: '.app-abo-us-pil__swi__nav--prev',
    },
    on: {
      slideChange: this.onSlideClick.bind(this),
    },
  };

  public onSlideClick($event: any): void {
    this.activeSlideIndex.set($event.realIndex);

    this.onSLideChangePushLayer($event);
  }

  public slieChangeLayer(pageCategory: string, slideTitle: string, destinationUrl: string): void {
    this._angulartics2GoogleTagManager.pushLayer({
      event: 'uaevent',
      ecommerce: 'undefined',
      eventCategory: pageCategory,
      eventAction: `select::slider navigation`,
      eventLabel: `${slideTitle}::${destinationUrl}`,
      event_name: 'slider_button_click',
      cta_name: slideTitle,
      link_url: destinationUrl,
    });
  }

  public onSLideChangePushLayer($event: any): void {
    let title = '';
    switch ($event.activeIndex) {
      case 0:
        title = 'PRO:EDUCATION';
        break;
      case 1:
        title = 'PRO:EXPERIENCE';
        break;
      case 2:
        title = 'PRO:SUPPORT';
        break;
    }
    this.slieChangeLayer('range page', title, '');
  }
}
